// extracted by mini-css-extract-plugin
export var chevron = "_ca-4";
export var chevronExpanded = "_ca-5";
export var row = "_ca-0";
export var rowBody = "_ca-6";
export var rowDescription = "_ca-7";
export var rowHeader = "_ca-1";
export var rowTitle = "_ca-2";
export var rowTitleComplete = "_ca-3";